import { PosterTemplatesAdminTab } from '@/components/admin/poster-templates-admin-tab';

export default function TemplatesPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">海报设计工作台</h1>
        <p className="mt-1 text-sm text-muted-foreground">设计可复用模板，替换内容制作海报。公共模板可复制，个人设计独立保存。</p>
      </div>
      <PosterTemplatesAdminTab />
    </div>
  );
}